var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('one-cms-product-fetcher-component',{attrs:{"id":_vm.productId},scopedSlots:_vm._u([{key:"default",fn:function({ product, isLoading }){return [_c('one-cms-dynamic-component',_vm._b({attrs:{"html":_vm.content,"product":product,"is-loading":isLoading}},'one-cms-dynamic-component',_vm.$attrs,false))]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }